import { useQuery } from '@tanstack/react-query';
import { queryKeys, pluginsService } from '@v2/services';

export const useActiveNonOfferingPlugins = (offeringName: string | null) => {
  const query = useQuery({
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    queryKey: queryKeys.plugins.activeNonOffering(offeringName!),
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    queryFn: () => pluginsService.getActiveNonOfferingPlugins(offeringName!),
    enabled: !!offeringName?.trim(),
  });

  return {
    plugins: query.data ?? [],
    loading: query.isLoading,
    error: query.error instanceof Error ? query.error.message : null,
    refetch: query.refetch,
  };
};

export default useActiveNonOfferingPlugins;
